import { PayloadAction, createSlice } from "@reduxjs/toolkit"

import { IBankMeta } from "../../api/interface"

export type IM2MSlice = {
  selectedBank: IBankMeta | null
  paymentType: "sbp"
  paymentMessage: string
  amount: string
}

const initialState: IM2MSlice = {
  selectedBank: null,
  paymentType: "sbp",
  paymentMessage: "",
  amount: "",
}

const m2mSlice = createSlice({
  name: "m2mPull",
  initialState,
  reducers: {
    setSelectedBank: (state, action: PayloadAction<IBankMeta | null>) => {
      if (
        action.payload &&
        state.selectedBank?.bankId !== action.payload.bankId
      ) {
        state.selectedBank = action.payload
      }
    },
    setPaymentType: (state) => {
      state.paymentType = "sbp"
    },
    setPaymentMessage: (state, action: PayloadAction<string>) => {
      state.paymentMessage = action.payload
    },
    setAmount: (state, action: PayloadAction<string>) => {
      state.amount = action.payload
    },
    resetSlice: () => initialState,
  },
})

export const {
  setSelectedBank,
  setAmount,
  setPaymentMessage,
  setPaymentType,
  resetSlice,
} = m2mSlice.actions

export default m2mSlice.reducer
